import { render, staticRenderFns } from "./NotificationsSubscribe.vue?vue&type=template&id=2c021312"
import script from "./NotificationsSubscribe.vue?vue&type=script&lang=js"
export * from "./NotificationsSubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports